
    (window.__NEXT_P=window.__NEXT_P||[]).push(["/_app", function() {
      var mod = require("next/dist/pages/_app")
      if(module.hot) {
        module.hot.accept("next/dist/pages/_app", function() {
          if(!next.router.components["/_app"]) return
          var updatedPage = require("next/dist/pages/_app")
          next.router.update("/_app", updatedPage)
        })
      }
      return mod
    }]);
  